import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
        path: '/',
        name: 'home',
        component: () => import('./pages/Home.vue'),
        children: [],
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue'),
        children: []
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('./pages/Register.vue'),
        children: []
    },
    {
        path: '/password_change',
        name: 'password_change',
        component: () => import('./pages/Password_reset.vue'),
        children: [],
        meta: { requiresAuth: true }
    },
    {
        path: '/password_reset',
        name: 'password_reset',
        component: () => import('./pages/Password_reset.vue'),
        children: [],
        meta: { requiresAuth: true }
    },
    /** Messages **/
    {
      path: '/messages',
      name: 'messages',
      component: () => import('./pages/messages/Index.vue'),
      children: [
        {
          path: '/messages/new',
          name: 'messages.new',
          component: () => import('./pages/messages/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/messages/:message_id',
          name: 'messages.view',
          component: () => import('./pages/messages/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/messages/:message_id/edit',
          name: 'messages.edit',
          component: () => import('./pages/messages/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/messages/:message_id/delete',
          name: 'messages.delete',
          component: () => import('./pages/messages/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Banners **/
    {
      path: '/banners',
      name: 'banners',
      component: () => import('./pages/banners/Index.vue'),
      children: [
        {
          path: '/banners/new',
          name: 'banners.new',
          component: () => import('./pages/banners/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banners/:banner_id',
          name: 'banners.view',
          component: () => import('./pages/banners/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banners/:banner_id/delete',
          name: 'banners.delete',
          component: () => import('./pages/banners/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/banners/:banner_id/edit',
      name: 'banners.edit',
      component: () => import('./pages/banners/Edit.vue'),
      meta: { requiresAuth: true }
    },
    /** Surveys **/
    {
      path: '/surveys',
      name: 'surveys',
      component: () => import('./pages/surveys/Index.vue'),
      children: [
        {
          path: '/surveys/new',
          name: 'surveys.new',
          component: () => import('./pages/surveys/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/surveys/:survey_id',
          name: 'surveys.view',
          component: () => import('./pages/surveys/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/surveys/:survey_id/delete',
          name: 'surveys.delete',
          component: () => import('./pages/surveys/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/surveys/:survey_id/edit',
      name: 'surveys.edit',
      component: () => import('./pages/surveys/Edit.vue'),
      meta: { requiresAuth: true }
    },
    /** Oferte OE **/
    {
      path: '/oferte',
      name: 'oferte',
      component: () => import('./pages/oferte/Index.vue'),
      children: [
        {
          path: '/oferte/new',
          name: 'oferte.new',
          component: () => import('./pages/oferte/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/oferte/:oferta_id',
          name: 'oferte.view',
          component: () => import('./pages/oferte/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/oferte/e/:oferta_id',
          name: 'oferte.eview',
          component: () => import('./pages/oferte/eView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/oferte/:oferta_id/delete',
          name: 'oferte.delete',
          component: () => import('./pages/oferte/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/oferte/:oferta_id/edit',
      name: 'oferte.edit',
      component: () => import('./pages/oferte/Edit.vue'),
      meta: { requiresAuth: true }
    },
    /** Searches **/
    {
      path: '/searches',
      name: 'searches',
      component: () => import('./pages/searches/Index.vue'),
      children: [],
      meta: { requiresAuth: true }
    },
    /** SearchIPS **/
    {
      path: '/searchips',
      name: 'searchips',
      component: () => import('./pages/searchips/Index.vue'),
      children: [],
      meta: { requiresAuth: true }
    },
    /** Search Limits **/
    {
      path: '/searchlimits',
      name: 'searchlimits',
      component: () => import('./pages/searchlimits/Index.vue'),
      children: [
        {
          path: '/searchlimits/new',
          name: 'searchlimits.new',
          component: () => import('./pages/searchlimits/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/searchlimits/:searchlimit_id',
          name: 'searchlimits.view',
          component: () => import('./pages/searchlimits/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/searchlimits/:searchlimit_id/edit',
          name: 'searchlimits.edit',
          component: () => import('./pages/searchlimits/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/searchlimits/find/:client/edit',
          name: 'searchlimits.ckedit',
          component: () => import('./pages/searchlimits/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/searchlimits/:searchlimit_id/delete',
          name: 'searchlimits.delete',
          component: () => import('./pages/searchlimits/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Banlist preturi gresite **/
    {
      path: '/banlistpgs',
      name: 'banlistpgs',
      component: () => import('./pages/banlistpgs/Index.vue'),
      children: [
        {
          path: '/banlistpgs/new',
          name: 'banlistpgs.new',
          component: () => import('./pages/banlistpgs/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlistpgs/:banlistpg_id',
          name: 'banlistpgs.view',
          component: () => import('./pages/banlistpgs/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlistpgs/:banlistpg_id/edit',
          name: 'banlistpgs.edit',
          component: () => import('./pages/banlistpgs/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlistpgs/find/:client/edit',
          name: 'banlistpgs.ckedit',
          component: () => import('./pages/banlistpgs/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlistpgs/:banlistpg_id/delete',
          name: 'banlistpgs.delete',
          component: () => import('./pages/banlistpgs/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Banlist clienti blocati **/
    {
      path: '/banlists',
      name: 'banlists',
      component: () => import('./pages/banlists/Index.vue'),
      children: [
        {
          path: '/banlists/new',
          name: 'banlists.new',
          component: () => import('./pages/banlists/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlists/:banlist_id',
          name: 'banlists.view',
          component: () => import('./pages/banlists/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlists/:banlist_id/edit',
          name: 'banlists.edit',
          component: () => import('./pages/banlists/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/banlists/:banlist_id/delete',
          name: 'banlists.delete',
          component: () => import('./pages/banlists/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Lista deconectari **/
    {
      path: '/disconnects',
      name: 'disconnects',
      component: () => import('./pages/disconnects/Index.vue'),
      children: [
        {
          path: '/disconnects/new',
          name: 'disconnects.new',
          component: () => import('./pages/disconnects/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/disconnects/:disconnect_id',
          name: 'disconnects.view',
          component: () => import('./pages/disconnects/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/disconnects/:disconnect_id/edit',
          name: 'disconnects.edit',
          component: () => import('./pages/disconnects/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/disconnects/:disconnect_id/delete',
          name: 'disconnects.delete',
          component: () => import('./pages/disconnects/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Banlist firewall iptables+ipset eOriginal **/
    {
      path: '/bans',
      name: 'bans',
      component: () => import('./pages/bans/Index.vue'),
      children: [
        {
          path: '/bans/new',
          name: 'bans.new',
          component: () => import('./pages/bans/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/bans/:ban_id/delete',
          name: 'bans.delete',
          component: () => import('./pages/bans/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Oferte OE Confirm **/
    {
      path: '/oferteconfirm',
      name: 'oferteconfirm',
      component: () => import('./pages/oferteconfirm/Index.vue'),
      children: [
        {
          path: '/oferteconfirm/new',
          name: 'oferteconfirm.new',
          component: () => import('./pages/oferteconfirm/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/oferteconfirm/:oferta_id',
          name: 'oferteconfirm.view',
          component: () => import('./pages/oferteconfirm/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/oferteconfirm/e/:oferta_id',
          name: 'oferteconfirm.eview',
          component: () => import('./pages/oferteconfirm/eView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/oferteconfirm/:oferta_id/delete',
          name: 'oferteconfirm.delete',
          component: () => import('./pages/oferteconfirm/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/oferteconfirm/:oferta_id/edit',
      name: 'oferteconfirm.edit',
      component: () => import('./pages/oferteconfirm/Edit.vue'),
      meta: { requiresAuth: true }
    },
    /** Users **/
    {
      path: '/users',
      name: 'users',
      component: () => import('./pages/Users/Index.vue'),
      children: [
        {
          path: '/users/:user_id/delete',
          name: 'users.delete',
          component: () => import('./pages/Users/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/users/new',
      name: 'users.new',
      component: () => import('./pages/Users/Create.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/users/:user_id',
      name: 'users.view',
      component: () => import('./pages/Users/View.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/users/:user_id/edit',
      name: 'users.edit',
      component: () => import('./pages/Users/Edit.vue'),
      meta: { requiresAuth: true }
    },
    /** Roles **/
    {
      path: '/roles',
      name: 'roles',
      component: () => import('./pages/Roles/Index.vue'),
      children: [
        {
          path: '/roles/:role_id/delete',
          name: 'roles.delete',
          component: () => import('./pages/Roles/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/roles/new',
      name: 'roles.new',
      component: () => import('./pages/Roles/Create.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/roles/:role_id',
      name: 'roles.view',
      component: () => import('./pages/Roles/View.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/roles/:role_id/edit',
      name: 'roles.edit',
      component: () => import('./pages/Roles/Edit.vue'),
      meta: { requiresAuth: true }
    },
    /** Api Users **/
    {
      path: '/apiusers',
      name: 'apiusers',
      component: () => import('./pages/apiusers/Index.vue'),
      children: [
        {
          path: '/apiusers/new',
          name: 'apiusers.new',
          component: () => import('./pages/apiusers/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/apiusers/:apiuser_id',
          name: 'apiusers.view',
          component: () => import('./pages/apiusers/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/apiusers/:apiuser_id/edit',
          name: 'apiusers.edit',
          component: () => import('./pages/apiusers/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/apiusers/:apiuser_id/delete',
          name: 'apiusers.delete',
          component: () => import('./pages/apiusers/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Cache Articles **/
    {
      path: '/cachearticles',
      name: 'cachearticles',
      component: () => import('./pages/cachearticles/Index.vue'),
      children: [
        {
          path: '/cachearticles/:cachearticle_id',
          name: 'cachearticles.view',
          component: () => import('./pages/cachearticles/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/cachearticles/:cachearticle_id/delete',
          name: 'cachearticles.delete',
          component: () => import('./pages/cachearticles/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Cache Filters **/
    {
      path: '/cachefilters',
      name: 'cachefilters',
      component: () => import('./pages/cachefilters/Index.vue'),
      children: [
        {
          path: '/cachefilters/:cachefilter_id',
          name: 'cachefilters.view',
          component: () => import('./pages/cachefilters/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/cachefilters/:cachefilter_id/delete',
          name: 'cachefilters.delete',
          component: () => import('./pages/cachefilters/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Cache Access oferte **/
    {
      path: '/cacheaccess',
      name: 'cacheaccess',
      component: () => import('./pages/cacheaccess/Index.vue'),
      children: [
        {
          path: '/cacheaccess/:accountkey/update',
          name: 'cacheaccess.update',
          component: () => import('./pages/cacheaccess/Update.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/cacheaccess/delete',
          name: 'cacheaccess.delete',
          component: () => import('./pages/cacheaccess/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Cache Access oferte **/
    {
      path: '/cachepieseschimb',
      name: 'cachepieseschimb',
      component: () => import('./pages/cachepieseschimb/Index.vue'),
      children: [
        {
          path: '/cachepieseschimb/:itemkey/update',
          name: 'cachepieseschimb.update',
          component: () => import('./pages/cachepieseschimb/Update.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/cachepieseschimb/delete',
          name: 'cachepieseschimb.delete',
          component: () => import('./pages/cachepieseschimb/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Cache Searches **/
    {
      path: '/cachesearches',
      name: 'cachesearches',
      component: () => import('./pages/cachesearches/Index.vue'),
      children: [
        {
          path: '/cachesearches/:cachesearch_id',
          name: 'cachesearches.view',
          component: () => import('./pages/cachesearches/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/cachesearches/:cachesearch_id/delete',
          name: 'cachesearches.delete',
          component: () => import('./pages/cachesearches/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Pagina contact **/
    {
      path: '/pagecontact',
      name: 'pagecontact',
      component: () => import('./pages/pagecontact/Index.vue'),
      children: [
        {
          path: '/pagecontact/new',
          name: 'pagecontact.new',
          component: () => import('./pages/pagecontact/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pagecontact/:warehouse_id',
          name: 'pagecontact.view',
          component: () => import('./pages/pagecontact/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pagecontact/:pagecontact_id/edit',
          name: 'pagecontact.edit',
          component: () => import('./pages/pagecontact/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pagecontact/:warehouse_id/delete',
          name: 'pagecontact.delete',
          component: () => import('./pages/pagecontact/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Pagina info **/
    {
      path: '/pageinfo',
      name: 'pageinfo',
      component: () => import('./pages/pageinfo/Index.vue'),
      children: [
        {
          path: '/pageinfo/:pageinfo_id/edit',
          name: 'pageinfo.edit',
          component: () => import('./pages/pageinfo/Edit.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Pagina downloads **/
    {
      path: '/pagedownload',
      name: 'pagedownload',
      component: () => import('./pages/pagedownloads/Index.vue'),
      children: [
        {
          path: '/pagedownload/new',
          name: 'pagedownload.new',
          component: () => import('./pages/pagedownloads/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pagedownload/:download_id',
          name: 'pagedownload.view',
          component: () => import('./pages/pagedownloads/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pagedownload/:download_id/edit',
          name: 'pagedownload.edit',
          component: () => import('./pages/pagedownloads/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pagedownload/:download_id/delete',
          name: 'pagedownload.delete',
          component: () => import('./pages/pagedownloads/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Pagina utile **/
    {
      path: '/pageutile',
      name: 'pageutile',
      component: () => import('./pages/pageutile/Index.vue'),
      children: [
        {
          path: '/pageutile/new',
          name: 'pageutile.new',
          component: () => import('./pages/pageutile/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pageutile/:item_id',
          name: 'pageutile.view',
          component: () => import('./pages/pageutile/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pageutile/:item_id/edit',
          name: 'pageutile.edit',
          component: () => import('./pages/pageutile/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/pageutile/:item_id/delete',
          name: 'pageutile.delete',
          component: () => import('./pages/pageutile/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Carcase baterii uzate **/
    {
      path: '/bateriiuzate',
      name: 'bateriiuzate',
      component: () => import('./pages/bateriiuzate/Index.vue'),
      children: [
        {
          path: '/bateriiuzate/new',
          name: 'bateriiuzate.new',
          component: () => import('./pages/bateriiuzate/Create.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/bateriiuzate/:item_id',
          name: 'bateriiuzate.view',
          component: () => import('./pages/bateriiuzate/View.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/bateriiuzate/:item_id/edit',
          name: 'bateriiuzate.edit',
          component: () => import('./pages/bateriiuzate/Edit.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/bateriiuzate/:item_id/delete',
          name: 'bateriiuzate.delete',
          component: () => import('./pages/bateriiuzate/Delete.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    /** Orders **/
    {
      path: '/orders',
      name: 'orders',
      component: () => import('./pages/orders/Index.vue'),
      children: [
        {
          path: '/orders/:order_id/:order_type',
          name: 'orders.view',
          component: () => import('./pages/orders/View.vue'),
          meta: { requiresAuth: true }
        }
      ],
      meta: { requiresAuth: true }
    },
    {
        path: '/test_sentry',
        name: 'test_sentry',
        component: () => import('./pages/TestSentry.vue'),
        children: [],
        meta: { requiresAuth: true }
    },
    //Always last
    {
        path: '*',
        component: () => import('./pages/Error404.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const loggednow = JSON.parse(localStorage.getItem('logged'))

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggednow && from.name !== 'login' && to.name !== 'login') {
      next({ name: 'login' })
    } else {
      if(
        loggednow &&
        router.app.$store.state.user.user &&
        router.app.$store.state.user.user.password_reset === true &&
        to.name !== 'password_reset'
      ) {
        next({ name: 'password_reset' })
      }
      next()
    }
  } else {
    if (loggednow === true && (to.name === 'login' || to.name === 'register')) {
      next({ name: 'home' })
    } else {
      next()
    }
  }
})

export default router;